import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * El título de un tema, siempre presionable: lleva a su ficha.
 *
 * Donde aparezca un tema se puede entrar a verlo, así que esto se usa en vez de
 * pintar el título a mano. Sin tema (o sin id con qué armar el enlace) cae al
 * texto tenue de siempre, para que las tablas no se llenen de enlaces muertos.
 *
 * Casi todos los sitios donde aparece un tema son filas que ya llevan a otra
 * parte —al estudiante, al proceso—, por eso se queda con el clic y con la
 * tecla: entrar al tema no es entrar a la fila.
 */
export default function EnlaceTema({
  id,
  titulo,
  vacio = "—",
}: {
  id?: number | null;
  titulo?: string | null;
  vacio?: string;
}) {
  if (!titulo) return <Box component="span" sx={{ color: "text.disabled" }}>{vacio}</Box>;
  if (!id) return <>{titulo}</>;

  return (
    <Link
      component={RouterLink}
      to={`/app/temas/${id}`}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      underline="hover"
      color="inherit"
      sx={{ fontWeight: "inherit" }}
    >
      {titulo}
    </Link>
  );
}
